"use client";

import { useTranslations } from "next-intl";
import Image from "next/image";

import { TripadvisorRating } from "~/components/tripadvisor-rating";
import { type ResponsiveImageProps, type TourProps } from "~/lib/fragments";
import { useCurrencyFormatter } from "~/lib/use-currency";
import { Link } from "~/navigation";
import { type RouterOutputs } from "~/trpc/types";

export type Tour = TourProps & {
  heroImage?: {
    responsiveImage?: ResponsiveImageProps | null;
  } | null;
};

export function InventoryCard({
  inventory,
}: {
  inventory: RouterOutputs["inventory"]["search"]["results"][0];
}) {
  const t = useTranslations("TourDetails");
  const formatCurrency = useCurrencyFormatter();
  return (
    <Link href={`/tours/${inventory.slug}/${inventory.id}`} prefetch={false}>
      {inventory.imageUrl ? (
        <Image
          alt=""
          className="aspect-4/5 mb-4 w-full rounded-lg object-cover"
          height={528}
          src={inventory.imageUrl}
          unoptimized
          width={440}
        />
      ) : null}
      <div className="flex flex-col gap-1">
        <div className="text-muted flex items-center justify-between gap-1 text-sm font-light leading-none">
          {inventory.tripadvisorRating ? (
            <TripadvisorRating
              size="small"
              value={inventory.tripadvisorRating / 10}
            />
          ) : null}
          <div>{inventory.locationName}</div>
        </div>
        <div className="line-clamp-3 font-medium leading-tight">
          {inventory.title}
        </div>
        <div className="text-muted flex items-center gap-1 text-sm font-light leading-tight">
          {t("fromAmount", {
            currencyAmount: formatCurrency(inventory.amount),
          })}{" "}
          {inventory.perPerson ? t("perPerson") : t("perGroup")}
        </div>
      </div>
    </Link>
  );
}
